<template>
  <input
    :class="['input', { readonly, disabled }]"
    :id="id"
    :type="type"
    :inputmode="inputmode"
    :readonly="readonly"
    :disabled="disabled"
    :value="value"
    :placeholder="placeholder"
    :required="required"
    :min="min"
    :max="max"
    :step="step"
    :pattern="pattern"
    :minlength="minlength"
    :maxlength="maxlength"
    :autofill="autofill"
    :autocomplete="autocomplete"
    v-on="inputListeners"
  />
</template>

<script>
export default {
  props: {
    id: String,
    type: { type: String, default: "text" },
    inputmode: String,
    disabled: Boolean,
    value: [String, Number],
    min: [String, Number],
    max: [String, Number],
    step: [String, Number],
    minlength: [String, Number],
    maxlength: [String, Number],
    readonly: [String, Boolean],
    required: [String, Boolean],
    pattern: String,
    placeholder: String,
    autofill: [String],
    autocomplete: [String]
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit("input", event.target.value);
        }
      };
    }
  }
};
</script>

<style scoped lang="scss">
.input {
  --input-background: var(--input-default-background);

  box-sizing: border-box;
  display: inline-block;
  flex: 1 1 auto;
  width: 100%;
  height: var(--input-height);
  padding: var(--input-padding-bordered);
  font-size: 1rem;
  line-height: var(--input-line-height);
  color: var(--text-color-base);
  background: var(--input-background);
  border: var(--input-border);
  border-radius: var(--input-border-radius);
  transition: border-color 200ms cubic-bezier(0.645, 0.045, 0.355, 1);
}
.readonly {
  background: transparent;
}
.disabled {
  --input-background: var(--input-disabled-background);
}
</style>
